import { VisionApplication } from '../../application';
import { VisionMap } from '../../map/map';
import { VisionRockPitsTab } from './rockpits_tab';

export class RockPitMap {
    parent: VisionRockPitsTab;
    map!: VisionMap;

    constructor(parent: VisionRockPitsTab) {
        this.parent = parent;

        this.parent.layout.cells('b').attachHTMLString('<div id="rockpit_map_id" style="width:100%;height:100%"></div>');
        this.parent.layout.cells('b').hideHeader();

        this.map = new VisionMap('rockpit_map_id');
        const app = VisionApplication.getInstance();
        this.map.init('rockpit_map', app.organizationService.dto?.latitude, app.organizationService.dto?.longitude).then(() => {
            console.log('Rock Pit Map Initialized');
        });
    }
}
